import { render, staticRenderFns } from "./followDetail.vue?vue&type=template&id=b117dec2&scoped=true&"
import script from "./followDetail.vue?vue&type=script&lang=js&"
export * from "./followDetail.vue?vue&type=script&lang=js&"
import style0 from "./followDetail.vue?vue&type=style&index=0&id=b117dec2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b117dec2",
  null
  
)

export default component.exports